import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Layout/Header';
import JobPostForm from '../components/JobPost/JobPostForm';
import OutputView from '../components/JobPost/OutputView';
import { generateJobPosting, generateJobPostingAlternative } from '../services/straicoService';
import toast from 'react-hot-toast';

const JobPostingPage = () => {
  const [generatedPost, setGeneratedPost] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [formData, setFormData] = useState(null);

  const handleGenerate = async (data) => {
    setIsGenerating(true);
    setFormData(data);
    
    try {
      console.log('Attempting to generate job posting with data:', data);
      
      let result;
      try {
        // Try the primary format first
        result = await generateJobPosting(data);
      } catch (primaryError) {
        console.log('Primary format failed, trying alternative:', primaryError.message);
        
        // If primary fails with 422, try alternative format
        if (primaryError.message.includes('422') || primaryError.message.includes('validation failed')) {
          try {
            result = await generateJobPostingAlternative(data);
          } catch (alternativeError) {
            console.log('Alternative format also failed:', alternativeError.message);
            throw alternativeError;
          }
        } else {
          throw primaryError;
        }
      }
      
      setGeneratedPost(result.jobPosting);
      toast.success('Job posting generated successfully!');
      
    } catch (error) {
      console.error('Generation error:', error);
      
      // Provide more specific error messages
      let errorMessage = error.message || 'Failed to generate job posting. Please try again.';
      
      if (error.message.includes('API key')) {
        errorMessage = 'API configuration error. Please check your Straico API key.';
      } else if (error.message.includes('Network')) {
        errorMessage = 'Network connection error. Please check your internet connection.';
      } else if (error.message.includes('422')) {
        errorMessage = 'Request format error. The API request format may have changed.';
      } else if (error.message.includes('rate limit')) {
        errorMessage = 'Too many requests. Please wait a moment and try again.';
      }
      
      toast.error(errorMessage);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleClear = () => {
    setGeneratedPost('');
    setFormData(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            AI Job Posting Generator
          </h1>
          <p className="text-gray-600">
            Create professional job postings with AI assistance
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <JobPostForm
              onGenerate={handleGenerate}
              isGenerating={isGenerating}
              onClear={handleClear}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <OutputView
              content={generatedPost}
              isGenerating={isGenerating}
              formData={formData}
            />
          </motion.div>
        </div>
      </main>
    </div>
  );
};

export default JobPostingPage;